import { workerstationService } from "@workerstation/shared/effect/service";
import { Context, Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup, HttpApiMiddleware, HttpApiSchema, HttpApiSecurity } from "effect/unstable/httpapi";
import { McpJsonRpcEnvelope, McpJsonRpcError, McpJsonRpcRequest } from "./http.ts";
import { McpProtectedResourceMetadata, type McpAuthClaims } from "./oauth.ts";

export class McpTransportPrincipal extends workerstationService<McpTransportPrincipal, McpAuthClaims>()("mcp/TransportPrincipal") {}
export class McpSecurity extends HttpApiMiddleware.Service<McpSecurity, { provides: McpTransportPrincipal }>()("workerstation/mcp/Security", {
  security: { bearer: HttpApiSecurity.bearer }
}) {}
const errors = /* @__PURE__ */ (() => [400, 401, 403, 405, 413, 500].map(status => McpJsonRpcError.annotate({ httpApiStatus: status })))();
const metadataErrors = /* @__PURE__ */ (() => [Schema.Literal("Not found").annotate({ httpApiStatus: 404 }).pipe(HttpApiSchema.asText()), Schema.Struct({ error: Schema.String }).annotate({ httpApiStatus: 405 }), errors[5]])();
export const McpApi = HttpApiGroup.make("mcp").add(
  HttpApiEndpoint.post("request", "/mcp", {
    payload: Schema.Union([McpJsonRpcRequest, Schema.Array(McpJsonRpcRequest)]),
    success: [McpJsonRpcEnvelope, Schema.Void.annotate({ httpApiStatus: 202 })], error: errors
  }).middleware(McpSecurity),
  HttpApiEndpoint.get("metadata", "/.well-known/oauth-protected-resource", { success: McpProtectedResourceMetadata, error: metadataErrors }),
  HttpApiEndpoint.get("metadataMcp", "/.well-known/oauth-protected-resource/mcp", { success: McpProtectedResourceMetadata, error: metadataErrors })
);
